import { useState } from 'react';
import PropTypes from 'prop-types';
import { cloudinaryThumbnail, cloudinaryFull } from '../../utils/formatCloudinary';
import Lightbox from '../Lightbox/Lightbox';
import Image from '../Image/Image';

RenderImage.propTypes = { params: PropTypes.object };

export function RenderImage({ params })
{
  const { pictures } = params.data;
  const [openLightbox, setOpenLightbox] = useState(false);

  return <>
    <Image
      alt="attachment"
      src={cloudinaryThumbnail(pictures?.[0])}
      sx={{
        height: 40,
        cursor: 'pointer',
        '&:hover': {
          opacity: 0.9,
        },
      }}
      onClick={() => setOpenLightbox(true)}
    />
    {pictures?.length > 0 && <Lightbox
      slides={pictures?.map((picture) => ({ src: cloudinaryFull(picture) }))}
      open={openLightbox}
      close={() => setOpenLightbox(false)}
    />}
  </>;
}

export default function AGGridPictureCol() {
  return {
    field: 'picture',
    headerName: 'Image',
    minWidth: 80,
    width: 80,
    cellRenderer: (params) => <RenderImage params={params} />,
    sortable: false,
    context: { ignoreResize: true }
  };
};

